module.exports = __webpack_public_path__ + "img/1572576700.0776edde.jpg";